import React from 'react';
import { DevErrorModal } from '~/components/Errors/DevErrorModal';

interface GlobalFallbackProps {
    error: CustomError;
}
export function GlobalFallback({ error }: GlobalFallbackProps) {
    return (
        <>
            <nav className="navbar navbar-expand navbar-dark shadow-sm">
                <div className="container-fluid">
                    <a href="/" className="navbar-brand">
                        <span aria-label="Leading Reach Zephyr" role="heading" aria-level={1} />
                        <img src="/lr-zephyr-reverse.png" alt="Leading Reach Zephyr" />
                    </a>
                </div>
            </nav>
            <main className="py-4">
                <div className="container">
                    <div className="row">
                        <div className="col text-center">
                            <div className="h4">Sorry, we encountered an error!</div>
                            <DevErrorModal error={error} />
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}
